export default function MessageBox($scope) {

    this.messages = [];

    /**
     * @param {String} message
     * @param {String} type
     */
    this.addMessage = function (message, type) {
        this.messages.push({
            message: message,
            type: type
        });
    };

    /**
     * @param {String} message
     */
    this.addError = function (message) {
        this.addMessage(message, 'error');
    };

    this.clear = function () {
        $scope.html('');
        this.messages = [];
    };

    this.render = function () {
        for (var i = 0; i < this.messages.length; i++) {
            $scope.append('<div class="' + this.messages[i].type + '">' + this.messages[i].message + '</div>');
        }

        if (this.messages.length > 0) {
            window.scrollTo(0, 0);
        }
    };

}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/MessageBox.js
 **/